module.exports = __webpack_public_path__ + "img/video.386be992.png";